import { Leaf } from "lucide-react";

const ITEMS = [
  "Psicologia Clínica",
  "Neuropsicologia",
  "Psicoterapia",
  "Avaliação Neuropsicológica",
  "Crianças",
  "Adolescentes",
  "Adultos",
  "Presencial",
  "Online",
];

const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    aria-hidden="true"
    className="overflow-hidden border-y border-raiz-900/10 bg-cream py-4"
  >
    <div className="marquee-track flex w-max items-center gap-8 pr-8">
      {[...ITEMS, ...ITEMS].map((item, i) => (
        <span key={i} className="flex items-center gap-8 whitespace-nowrap">
          <span className="font-serif text-sm italic tracking-wide text-raiz-800/75">{item}</span>
          <Leaf className="h-3.5 w-3.5 text-gold-500" />
        </span>
      ))}
    </div>
  </div>
);

export default Marquee;
